import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://propmeister.art";
const DEFAULT_IMAGE = "https://propmeister.art/images/hero.jpg";

const Seo = ({ title, description, path = "", image = DEFAULT_IMAGE, type = "website" }) => {
  const fullTitle = title
    ? `${title} · Jesse J. Adams — LA Property Master`
    : "Jesse J. Adams — Los Angeles Property Master · IATSE Local 44";
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default Seo;
